import { render, staticRenderFns } from "./TripsRightSidebar.vue?vue&type=template&id=15a0ca67&scoped=true&"
import script from "./TripsRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./TripsRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TripsRightSidebar.vue?vue&type=style&index=0&id=15a0ca67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0ca67",
  null
  
)

export default component.exports